import ImportHelper from './import.helper'

const intro = () => {return ImportHelper.importAll(require.context("../assets/intro/", true, /\.jpg/))}
const backgrounds = () => {return ImportHelper.importAll(require.context("../assets/backgrounds/", true, /\.jpg/))}

const E2 = () => {return ImportHelper.importAll(require.context("../assets/images/E2/", true, /\.jpg/))}
const E2Thumbs = () => {return ImportHelper.importAll(require.context("../assets/images/E2/Thumbs/", true, /\.jpg/))}

const GalleriaE2Thumbs = () => {return ImportHelper.importAll(require.context("../assets/gallery/E2/", true, /\.jpg/))}
const GalleriaYuan300 = () => {return ImportHelper.importAll(require.context("../assets/gallery/YUAN300/", true, /\.jpg/))}
const GalleriaYuan400 = () => {return ImportHelper.importAll(require.context("../assets/gallery/YUAN400/", true, /\.jpg/))}
const GalleriaT3 = () => {return ImportHelper.importAll(require.context("../assets/gallery/T3/", true, /\.jpg/))}
const GalleriaM3 = () => {return ImportHelper.importAll(require.context("../assets/gallery/M3/", true, /\.jpg/))}
const GalleriaSONGPRO = () => {return ImportHelper.importAll(require.context("../assets/gallery/SONGPRO/", true, /\.jpg/))}

const VideosYuan300 = () => {return ImportHelper.importAll(require.context("../assets/gallery/VideosYUAN300/", true, /\.jpg/))}
const VideosSONGPRO = () => {return ImportHelper.importAll(require.context("../assets/gallery/VideosSONGPRO/", true, /\.jpg/))}

const InteriorE2 = () => {return ImportHelper.importAll(require.context("../assets/interiors/E2/", true, /\.jpg/))}
const InteriorYuan300 = () => {return ImportHelper.importAll(require.context("../assets/interiors/YUAN300/", true, /\.jpg/))}
const InteriorYuan400 = () => {return ImportHelper.importAll(require.context("../assets/interiors/YUAN400/", true, /\.jpg/))}
const InteriorM3 = () => {return ImportHelper.importAll(require.context("../assets/interiors/M3/", true, /\.jpg/))}
const InteriorT3 = () => {return ImportHelper.importAll(require.context("../assets/interiors/T3/", true, /\.jpg/))}
const InteriorSongPro = () => {return ImportHelper.importAll(require.context("../assets/interiors/SONGPRO/", true, /\.jpg/))}

export const ContextLoader: any = {
    'HATCHBACK EV' : E2,
    
    'Interior HATCHBACK EV': InteriorE2,
    'Interior YUAN 300': InteriorYuan300,
    'Interior YUAN 400': InteriorYuan400,
    'Interior M3': InteriorM3,
    'Interior T3': InteriorT3,
    'Interior SONG PRO': InteriorSongPro,
    
    'intro': intro,
    'backgrounds': backgrounds,

    'Galeria HATCHBACK EV': GalleriaE2Thumbs,
    'Galeria YUAN 300': GalleriaYuan300,
    'Galeria YUAN 400': GalleriaYuan400,
    'Galeria T3': GalleriaT3,
    'Galeria M3': GalleriaM3,
    'Galeria SONG PRO': GalleriaSONGPRO,

    'Videos YUAN 300': VideosYuan300,
    'Videos SONG PRO': VideosSONGPRO,

    'Thumbs HATCHBACK EV': E2Thumbs,
}